<template>
  <el-row :gutter="18"
          class="edit">
    <el-col :md="14">
      <div class="content-map">
        <MapZonesModify ref="map"
                        @save="save"
                        height="400px"
                        :polygon="sector.polygon"/>
      </div>
    </el-col>
    <el-col :md="10">
      <el-form :model="sector">
        <!-- Sector Name-->
        <el-form-item label="Nombre del sector">
          <el-input v-model="sector.name"
                    size="mini"/>
        </el-form-item>
        <!-- Enterprise -->
        <el-form-item label="Empresa">
          <el-select  v-model="sector.enterprise"
                      value-key="id"
                      clearable
                      size="mini"
                      filterable
                      @change="getDataPatent"
                      placeholder="Ej: nombre empresa">
            <el-option  v-for="enterprise in enterpriseList"
                        :key="enterprise.id"
                        :label="enterprise.name"
                        :value="{ id: enterprise.id, name: enterprise.name }"/>
          </el-select>
        </el-form-item>
        <!-- Vehicles -->
        <el-form-item label="Patentes">
          <el-select  v-model="sector.vehicles"
                      :disabled="this.myPatents.length < 1"
                      multiple
                      size="mini"
                      filterable
                      clearable
                      collapse-tags
                      placeholder="Ej: TEST-123"
                      class="mini-loader"
                      v-loading="loadPatent"
                      @change="updateMaximumVolume()">
            <el-option  v-for="vehicle in myPatents"
                        :key="vehicle.id"
                        :label="vehicle.patent"
                        :value="vehicle.id"/>
          </el-select>
        </el-form-item>
        <!-- Package Type -->
        <el-form-item label="Tamaño">
          <el-checkbox v-model="checkAllPackage"
                       class="btn-select-all"
                       @change="selectAllPackages">
            <span class="check-label">seleccionar todos los tamaños</span>
          </el-checkbox>
          <el-select  v-model="sector.packageTypes"
                      value-key="id"
                      multiple
                      clearable
                      size="mini"
                      collapse-tags
                      filterable
                      @change="verifySelected('packages')"
                      placeholder="Ej: MM">
            <el-option  v-for="packageType in packageTypeList"
                        :key="packageType.id"
                        :label="packageType.type"
                        :value="{ id: packageType.id, type: packageType.type }"/>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="option">
      <el-button size="small"
                 class="danger"
                 @click="remove">
        <i class="far fa-trash-alt"/>ELIMINAR
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import MapZonesModify from '../../../maps/MapZonesModifyV2.vue';
import { cachedAPIRequest } from '../../../../../mixins/cacheDim';

export default {
  name: 'PolygonForm',
  components: {
    MapZonesModify,
  },
  props: {
    sector: {
      type: Object,
      default() {
        return {};
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      myPatents: [],
      loadPatent: false,
      enterpriseList: [],
      packageTypeList: [],
      checkAllPackage: false,
    };
  },
  mounted() {
    this.getEnterpriseList();
    this.getPackageTypeList();
    if (this.sector.enterprise.id) this.getPatents();
    this.verifySelected('packages');
  },
  methods: {
    save(polygon) {
      this.sector.polygon = polygon;
    },
    remove() {
      this.$confirm('¿Está seguro que desea eliminar el sector?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.$emit('remove');
      }).catch(() => {});
    },
    verifySelected(type) {
      if (type === 'packages') this.checkAllPackage = this.allPackagesSelected;
    },
    selectAllPackages(value) {
      this.sector.packageTypes = value ? this.packageTypeList : [];
    },
    updateMaximumVolume() {
      this.sector.maximumVolume = this.calculateVolumen();
      this.sector.maximumPrice = this.calculatePrice();
    },
    calculateVolumen() {
      return this.sector.vehicles.reduce((acc, id) => {
        const measure = this.myPatents.find(v => v.id === id);
        return acc + measure.max_volume;
      }, 0);
    },
    calculatePrice() {
      return this.sector.vehicles.reduce((acc, id) => {
        const price = this.myPatents.find(v => v.id === id);
        return acc + price.max_insurance;
      }, 0);
    },
    getEnterpriseList() {
      this.enterpriseList = this.data.enterpriseList;
    },
    getPackageTypeList() {
      this.packageTypeList = this.data.packageTypeList;
    },
    getDataPatent() {
      this.sector.vehicles = [];
      if (this.sector.enterprise.id) this.getPatents();
    },
    getPatents() {
      this.loadPatent = true;
      cachedAPIRequest({
        module: 'planning',
        service: 'get_patents',
        pathparam: { id: this.sector.enterprise.id },
        params: { limit: 1000 },
      }).then((data) => {
        this.myPatents = data.data.sort((a, b) => (b.patent > a.patent ? -1 : 1));
        this.loadPatent = false;
        if (this.myPatents.length < 1) {
          this.$notify.warning({
            title: 'Advertencia',
            message: 'Empresa sin patentes activas',
          });
        }
      }).catch(() => {
        this.loadPatent = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las patentes',
        });
      });
    },
  },
  computed: {
    allPackagesSelected() {
      return this.sector.packageTypes.length === this.packageTypeList.length;
    },
  },
};
</script>

<style lang="scss" scoped>
  .edit {
    padding: 20px 10px 10px;
    .el-form-item { margin-bottom: 12px; }
    .btn-select-all {
      float: right;
      height: 25px;
      margin: -18px 2px 0 0;
      .check-label {
        font-size: 11px;
        margin-left: -4px;
      }
    }
    .content-map {
      border-radius: 3px;
      .el-button { margin: 6px; }
    }
    .option {
      text-align: right;
      i {
        margin-right: 8px;
        margin-left: -5px;
      }
    }
  }
</style>
